
if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.stickyDisabled   = this.getAttribute('disabled') === 'true';
      this.headerSection    = document.querySelector('.section-header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mainNavToggle    = this.querySelector('main-nav-toggle');
      this.THRESHOLD        = 10;
      this.compact          = false;
      this.ticking          = false;

      if (this.stickyDisabled) return;

      // Measure full header height ONCE before any changes
      this._fullHeight = this.headerSection.getBoundingClientRect().height;

      // Switch to fixed positioning
      this.headerSection.style.cssText =
        'position:fixed;top:0;left:0;right:0;z-index:200;width:100%;';

      // Apply offset to the main content area so it starts below the header
      this._applyBodyOffset(this._fullHeight);

      this._onScroll = () => {
        if (!this.ticking) {
          requestAnimationFrame(() => { this._update(); this.ticking = false; });
          this.ticking = true;
        }
      };

      this._onResize = () => {
        this.headerSection.classList.remove('pvf-header-compact');
        this._fullHeight = this.headerSection.getBoundingClientRect().height;
        this._applyBodyOffset(this._fullHeight);
        this._update();
      };

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      this._applyBodyOffset(0);
    }

    _applyBodyOffset(height) {
      const main = document.querySelector('#MainContent, main[id="MainContent"], .main-content, main');
      if (main) {
        main.style.paddingTop = height + 'px';
      } else {
        document.body.style.paddingTop = height + 'px';
      }
      document.documentElement.style.scrollPaddingTop = height + 'px';
    }

    _isMobile() {
      return window.innerWidth < 990;
    }

    // Called by native scripts.js when mobile menu opens — must exist
    reveal() {
      // On mobile we're always visible (fixed), nothing to do
      // On desktop, remove compact state temporarily if needed
      if (!this._isMobile()) {
        this.headerSection.classList.remove('pvf-header-compact');
      }
    }

    // Some themes also call hide() — stub it out so it doesn't crash
    hide() {}

    _update() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // On mobile: never enter compact mode — let the native mobile header handle itself
      if (this._isMobile()) {
        this.headerSection.classList.remove('pvf-header-compact');
        return;
      }

      const scrolled = window.scrollY > this.THRESHOLD;
      if (scrolled === this.compact) return;
      this.compact = scrolled;

      if (scrolled) {
        this.headerSection.classList.add('pvf-header-compact');
        if (this.mainNavToggle) this.mainNavToggle.enable();
      } else {
        this.headerSection.classList.remove('pvf-header-compact');
        if (this.mainNavToggle) this.mainNavToggle.disable();
      }
    }
  });
}

if (!customElements.get('main-nav-toggle')) {
  customElements.define('main-nav-toggle', class MainNavToggle extends HTMLElement {
    connectedCallback() {
      this.header            = document.querySelector('#header');
      this.navigationWrapper = document.querySelector('.navigation-wrapper');
    }

    enable() {
      if (!this.header) return;
      this.header.classList.add('header-nav-collapse-enabled', 'navigation-collapsed');
      if (this.navigationWrapper) {
        this.navigationWrapper.style.maxHeight  = '0';
        this.navigationWrapper.style.overflow   = 'hidden';
        this.navigationWrapper.style.opacity    = '0';
      }
    }

    disable() {
      if (!this.header) return;
      this.header.classList.remove('header-nav-collapse-enabled', 'navigation-collapsed');
      if (this.navigationWrapper) {
        this.navigationWrapper.style.maxHeight  = '';
        this.navigationWrapper.style.overflow   = '';
        this.navigationWrapper.style.opacity    = '';
      }
    }
  });
}
